module.exports = __webpack_public_path__ + "static/media/step-1.458fece6.png";